export default __webpack_public_path__ + "static/media/TVinsure-Covid-Card-Vib.3fdb8ac3.jpg";